import { render, staticRenderFns } from "./OnboardingMatchingLanguagesPage.vue?vue&type=template&id=9643d622&scoped=true&"
import script from "./OnboardingMatchingLanguagesPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMatchingLanguagesPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMatchingLanguagesPage.vue?vue&type=style&index=0&id=9643d622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9643d622",
  null
  
)

export default component.exports